import {createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
import rootReducer from './Reducers/MainReducer';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
const persistConfig = {
    key: 'root',
    storage,
  }
  
  const persistedReducer:any = persistReducer<any>(persistConfig,rootReducer)
 
  const middleware = [thunk]
let store = createStore(persistedReducer,composeWithDevTools(applyMiddleware(...middleware)))
  
  //export default store;
  let persistor = persistStore(store)
  export  {store,persistor}